import authUtils from '../../utils/authUtils';

export const PAYROLL_PATHS = {
    configuration: '/cauhinh_congluong',
    templates: '/maubangluong',
    agreements: '/thoathuan_congluong',
    advances: '/ungluong',
    periods: '/bangcongluong',
    reports: '/baocao_congluong',
    holidays: '/lichngayle',
    leave: '/phepnam',
    retention: '/sotiengiulai',
};

export function currentPayrollUser() {
    const user = authUtils.getUserData() || {};
    return {
        username: user.username || '',
        name: user['Họ và Tên'] || user.username || '',
        role: user['Phân quyền'] || '',
    };
}

// Sửa cấu hình và dữ liệu lương: chỉ Admin và Quản lý. Người được cấp quyền xem trang chỉ xem.
export function canManagePayroll() {
    const { role } = currentPayrollUser();
    return role === 'Admin' || role === 'Quản lý';
}

export function canViewPayrollPage(path) {
    return authUtils.hasMenuPermission(path);
}

export function assertCanManagePayroll() {
    if (!canManagePayroll()) throw new Error('Chỉ Admin hoặc Quản lý mới được sửa dữ liệu lương.');
}
